import React, { useState, useEffect } from "react";
import ChatWidget from "./ChatWidget";
import ApiClient from "../../API/api";

const TenantChatWidget = () => {
    const [chatConfig, setChatConfig] = useState(null);

    useEffect(() => {
        ApiClient.performRequest("chat/config")
            .then(setChatConfig)
            .catch(() => {});
    }, []);

    if (!chatConfig?.enabled || !chatConfig?.url) return null;

    return <ChatWidget chatUrl={chatConfig.url} />;
};

export default TenantChatWidget;
